import React from "react";

import { fmtBRL, fmtInt } from "./formatos";

// Faixa de cobertura do Cotado × Realizado (PO1-3621): o realizado vem só dos
// CT-es recebidos pelo TMS; transportadora que não envia CT-e não aparece no
// realizado. Lista as transportadoras do período com NF de venda e nenhum CT-e,
// e quantos CT-es ficaram fora (anulação/substituto).
export default function FaixaCobertura({ cobertura, transportadorasSemEnvio }) {
  if (!cobertura) return null;
  const semCte = cobertura.transportadorasSemCte || [];
  const semEnvio = transportadorasSemEnvio || [];
  const naoConsiderados = Number(cobertura.ctesNaoConsiderados || 0);
  const vazio = Boolean(cobertura.semCteNoTms);

  return (
    <div className={`cr-cobertura${vazio ? " cr-cobertura--vazio" : ""}`} role="note">
      <i className="tim-icons icon-alert-circle-exc cr-cobertura__icone" />
      <div>
        <div className="cr-cobertura__titulo">
          {vazio
            ? "Nenhum CT-e deste embarcador chegou ao TMS no período."
            : "Dados de CT-e recebidos pelo TMS; transportadoras sem envio de CT-e não aparecem no realizado."}
        </div>
        {vazio ? (
          <div>
            O frete realizado e o valor da mercadoria ficam vazios até as transportadoras enviarem os CT-es
            (SFTP, API ou captura na SEFAZ). O frete cotado e as notas continuam disponíveis.
          </div>
        ) : null}
        {semCte.length > 0 ? (
          <>
            <div>Transportadoras com NF de venda no período e nenhum CT-e recebido:</div>
            <ul className="cr-cobertura__lista">
              {semCte.map((t) => (
                <li key={t.idMatriz}>
                  <strong>{t.nome}</strong> · {fmtInt(t.nfs)} NF(s) · {fmtBRL(t.valorNf)} em mercadoria
                </li>
              ))}
            </ul>
          </>
        ) : null}
        {semEnvio.length > 0 && semCte.length === 0 ? (
          <div>
            Transportadoras sem envio de CT-e no período: {semEnvio.map((t) => t.nome).join(", ")}.
          </div>
        ) : null}
        {naoConsiderados > 0 ? (
          <div className="cr-cobertura__nota">
            {fmtInt(naoConsiderados)} CT-e(s) de anulação ou substituição ficaram fora do realizado.
          </div>
        ) : null}
      </div>
    </div>
  );
}
